import { Component, OnInit } from '@angular/core';
import { GroupsModel } from 'src/app/models/GroupsModel';
import { GroupsService } from 'src/app/services/GroupsService';
import { UsersModel } from 'src/app/models/UsersModel';
import { UsersService } from 'src/app/services/UsersService';
import { UsersearchComponent } from '../usersearch/usersearch.component';
import { LocalStorageService } from 'ngx-webstorage';
import { formatDate } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';

import { DomSanitizer } from '@angular/platform-browser';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { DoctorsService } from 'src/app/services/DoctorsService';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  grupsCode = '';
  groupsame = '';
  groupsNotes = '';
  compCode = '1';

    userID = '';
    userName = '';
    enabled = '';
    empID = '';
    groupCode = '';
    password = '';
    userID1 = '';
    myimage :any;

    modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    imageSrc;
    groupsList: GroupsModel[] =[];
    doctorList : DoctorsModel[]=[];

    imageSource: any;

    wk_DoctorHeddin = true;

    sellersPermitFile: any;
    sellersPermitString = '';

    wk_Pic_Not = false;
    wk_Pic_Not1 = true;


  constructor(public groupsService: GroupsService,
    public usersService: UsersService,
    public users: UsersModel,
    public doctorsService : DoctorsService,
    public storage: LocalStorageService,
    public usersSelectedData: UsersModel,                ///----------- for searching pop up -----------
    private dialogref: MatDialog,
    private sanitizer: DomSanitizer                     ///----------- for searching pop up -----------
  ) { }

  ngOnInit(): void {
    this.retriveGroupsLookupTop();
    this.retriveDoctorsLookupTop()
    this.wk_Pic_Not = false;
    this.wk_Pic_Not1 = true;

  }
  retriveGroupsLookupTop() {                                      ///------------ Fill the Droup Down Groups
    this.groupsService
      .getGroupsLookupTop(this.compCode)
      .subscribe((data: GroupsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.groupsList[i] = data[i];
        }
        //console.log(data);
      });
  }
  retriveDoctorsLookupTop() {                                      ///------------ Fill the Droup Down Groups
    this.doctorsService .getDoctorsLookupTop('1')
      .subscribe((data: DoctorsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.doctorList[i] = data[i];
        }

      });
  }
  Heddin_DoctorCode(){
    if(this.groupCode = '2'){
    this.wk_DoctorHeddin = false}
    else
    {
      this.wk_DoctorHeddin = true}


  }
  retriveUsers() {
    this.usersService.getusers(this.userID, this.storage.retrieve('stgcompCode')).subscribe((data: UsersModel) => {

      this.userName = data.userName;
      this.enabled = data.enabled;
      this.empID = data.empID;
      this.groupCode = data.groupCode;
      this.password = data.password;
      this.compCode = data.compCode;
      this.userID1 = data.userID1;
      this.modifiedDate = data.modifiedDate;
      this.retrivePic();
       }

    );
  }
 retrivePic(){
  this.usersService.getusersPic(this.userID, this.storage.retrieve('stgcompCode')).subscribe((data: UsersModel) => {
    this.myimage = data.iTPicture;
    this.sellersPermitString =  data.iTPicture;
    this.myimage =this.sellersPermitString;
    var kk = this.sellersPermitString;

    this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.sellersPermitString);
    if(data.iTPicture =='' || data.iTPicture == null)
      {
        this.wk_Pic_Not = false;
        this.wk_Pic_Not1 = true;
      }
      else
      {
        this.wk_Pic_Not = true;
        this.wk_Pic_Not1 = false;
      }
  }

  );
 }

  submitUsers() {
    this.users.userID = this.userID;
    this.users.userName = this.userName;
    this.users.enabled = this.enabled;
    this.users.groupCode = this.groupCode;
    this.users.empID = this.empID;
    this.users.password = this.password;
    this.users.userID1 = this.storage.retrieve('stguserId');
    this.users.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.users.compCode = this.storage.retrieve('stgcompCode');

    this.usersService.Addusers(this.users).subscribe(data => {

      this.submitPic();
      this.mesgSave();
    },

      error => { alert(error); }

    );

  }
  submitPic(){
    if(this.sellersPermitString !=null){
    this.users.userID = this.userID;

    this.users.userID1 = this.storage.retrieve('stguserId');
    this.users.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.users.iTPicture = this.sellersPermitString;
    this.users.compCode = this.storage.retrieve('stgcompCode');

    this.usersService.AddusersPic(this.users).subscribe(data => {

      this.mesgSave();
    },

      error => { alert(error); }

    );
  }
   }
  NewData() {
    this.userID = '';
    this.userName = '';
    this.enabled = '';
    this.empID = '';
    this.groupCode = '';
    this.password = '';
    this.myimage = '';
    this.compCode = this.storage.retrieve('stgcompCode');
    this.userID1 = this.storage.retrieve('stguserId');
    this.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.wk_Pic_Not = false;
    this.wk_Pic_Not1 = true;
  }
  deleteUsers() {                                                   ///----------- for searching pop up -----------
    this.usersService.delusers(this.userID, this.storage.retrieve('stgcompCode')).subscribe(
      (data: UsersModel) => {
        this.userID = data.userID;
        this.userName = data.userName;
        this.enabled = data.enabled;
        this.empID = data.empID;
        this.groupCode = data.groupCode;
        this.password = data.password;

        this.compCode = data.compCode;
        this.userID1 = data.userID1;
        this.modifiedDate = data.modifiedDate;
      }
    );
  }
  openDialog() {
    const dialogRef = this.dialogref.open(UsersearchComponent,
      {
        data: {
          dataKey: this.usersSelectedData
        },
        width:'80%'
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.userID = result.userID;
        this.userName = result.userName;
        this.enabled = result.enabled;
        this.empID = result.empID;
        this.groupCode = result.groupCode;
        this.password = result.password;

        this.compCode = result.compCode;
        this.userID1 = result.userID1;
        this.modifiedDate = result.modifiedDate;
        this.retrivePic();
        dialogSubmitSubscription.unsubscribe();

      });
  }
  mesgDelete() {
    //console.log('in msg delete');
    Swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(() => {
      this.deleteUsers();
      Swal('Deleted!', 'Your record has been deleted.', 'success');

    },
      function (dismiss) {
        if (dismiss === 'cancel') {
          Swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }

  public picked(event: any) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      this.sellersPermitFile = file;

      this.handleInputChange(file); //turn into base64

    }
    else {
      alert("No file selected");
    }
  }
  handleInputChange(files: any) {
    var file = files;
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }

    reader.onloadend = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }
  _handleReaderLoaded(e: any) {
    let reader = e.target;
    var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    this.imageSrc = base64result;
    this.sellersPermitString = base64result;
    this.myimage =this.sellersPermitString;
    var kk = this.sellersPermitString;

    this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.sellersPermitString);

    if(this.imageSource =='' || this.imageSource == null)
      {
        this.wk_Pic_Not = false;
        this.wk_Pic_Not1 = true;
      }
      else
      {
        this.wk_Pic_Not = true;
        this.wk_Pic_Not1 = false;
      }
  }

  log() {
    // for debug

    this.myimage =this.sellersPermitString;
    //console.log('1', this.sellersPermitString);
  }
  mesgSave() {
    Swal({
      title: 'Your work has been saved',

      type: 'success',
      showConfirmButton: false,

      timer: 1500
    });
  }
}
